import ExtendableTable from '@/components/ExtendableTable';
import InlineEdit from '@/components/InlineEdit';
import { useQualityDetailContext } from '@/contexts/QualityContext';
import useCognitoUsers from '@/hooks/useCognitoUsers';
import { DETAIL_MODE, DETAIL_TYPE, useDetailMode } from '@/hooks/useDetailMode';
import { filterUsersByRole } from '@/lib/approvals';

const ApprovalsTable = ({
  hideButtons: hideButtonsProp,
  name,
  required,
  title,
  users,
}) => {
  const { mode } = useDetailMode(DETAIL_TYPE.QUALITY);
  const { form, setFormByKey } = useQualityDetailContext();

  const filteredUsers = filterUsersByRole(users, name);

  const selectedOptions =
    form.reviewers?.[name]?.map((row) => row?.value?.sub || row?.sub || row) ||
    [];

  return (
    <div className="space-y-4">
      <h4 className="mb-3 font-bold">
        {title}
        {required && <span className="text-destructive"> *</span>}
      </h4>
      <ExtendableTable
        columns={[
          {
            className: 'w-14',
            label: 'S/N',
            name: 'series',
            renderField: (_, index) => (
              <div className="text-center">
                {String(index + 1).padStart(2, '0')}
              </div>
            ),
          },
          {
            className: 'w-2/5',
            label: 'Name',
            name: 'sub',
            renderField: ({ onChange, value }) => (
              <InlineEdit
                disabled={mode === DETAIL_MODE.STATIC}
                onChange={(sub) => {
                  const user = filteredUsers.find((u) => u.sub === sub);
                  onChange(user ? { sub: user.sub, name: user.name, designation: user.designation } : { sub, name: sub });
                }}
                options={filteredUsers.map((item) => ({
                  ...item,
                  disabled: selectedOptions.includes(item.sub),
                }))}
                placeholder={mode === DETAIL_MODE.STATIC ? '' : 'Select name...'}
                type="select"
                value={value}
              />
            ),
          },
          {
            label: 'Designation',
            name: 'designation',
            renderField: (_, __, fieldValue) => (
              <div>
                {fieldValue?.designation || '\u2014'}
              </div>
            ),
          },
        ]}
        disabled={mode === DETAIL_MODE.STATIC}
        hideButtons={mode === DETAIL_MODE.STATIC || hideButtonsProp}
        onChange={(value) =>
          setFormByKey('reviewers', {
            ...(form.reviewers || {}),
            [name]: value,
          })
        }
        value={form.reviewers?.[name]}
      />
    </div>
  );
};

const QualityApprovalsView = () => {
  const { users } = useCognitoUsers();

  return (
    <div className="space-y-4">
      <ApprovalsTable
        hideButtons
        name="qmrQa"
        required
        title="QMR or Assigned QA for Review"
        users={users}
      />
      <ApprovalsTable
        name="processOwners"
        required
        title="List of Process Owner(s) for Review"
        users={users}
      />
      <ApprovalsTable
        name="managementApprovers"
        required
        title="Management or Assigned Personnel for Approval"
        users={users}
      />
    </div>
  );
};

export default QualityApprovalsView;
